import { enrichFavouritesResponse, sortFavourites } from "lib/favourites";

export const getFavourites = async (axiosInstance, dataApi) => {
  if(!axiosInstance) {
    return
  }
  try {
    const response = await axiosInstance.get();
    return sortFavourites(await enrichFavouritesResponse(dataApi, response.data.result));
  } catch (error) {
    console.log('Get Favourites Error: ', error);
  }
};

export const deleteFavourite = async (axiosInstance) => {
  try {
    return await axiosInstance.delete();
  } catch (error) {
    console.log('Delete Favourites Error: ', error);
  }
};

export const addFavourite = async (axiosInstance, fare) => {
  try {
    const body = {
      origin: fare.origin.nlc,
      destination: fare.destination.nlc,
      children: fare.children,
      adults: fare.adults,
      ticketType: fare.ticketType.code,
      smartTicketType: fare.smartTicketType,
      railcards: [],
      route: fare.route.code,
      isSmartcard: fare.isSmartcard,
      isFlexi: fare.ticketType.isFlexi,
      isSeason: fare.ticketType.isSeason,
      isOpenReturn: fare.isOpenReturn,
      fareClass: fare.fareClass,
      duration: [fare.duration],
      passenger: fare.passenger,
      delivery: {
        ...fare.delivery,
        collectionLocation: fare.delivery.collectionLocation?.nlc,
      }
    }
    return await axiosInstance.post('', body);
  } catch (error) {
    console.log('Add Favourite Error ', error);
  }
}
